import React from 'react';
import '../../styles/LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Top Navigation */}
      <header className="top-nav">
        <div className="logo">
          <img src="/images/prtc-logo-wh.png" alt="PRTC Logo" />
        </div>
        <nav className="nav-links">
          <a href="#">Home</a>
          <a href="#">Internet</a>
          <a href="#">Video</a>
          <a href="#">Voice</a>
          <a href="#">Wireless</a>
          <a href="#">Security and Home Automation</a>
          <a href="#">Contact Us</a>
        </nav>
        <div className="nav-icons">
          <button>
            <i className="fas fa-search"></i>
          </button>
          <button>
            <i className="fas fa-shopping-cart"></i>
          </button>
        </div>
      </header>

      {/* Main Hero Section */}
      <main className="hero-section">
        <div className="hero-image">
          <img src="/images/landingpagebg.png" alt="Family on laptop" />
        </div>
        <div className="hero-text">
          <h2 className="highlight">THE CONNECTION IS YOU</h2>
          <h1>
            Power Your Connected Life with <br /> Reliable, High-Speed Services
          </h1>
          <p>
            PRTC provides the high-speed services you need at a price you can
            afford.
            <br />
            Experience unmatched reliability, unparalleled speed, and unrivaled
            customer support with a local company you can trust!
          </p>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
